// Email Template Fields Configuration
// This file makes it easy to add new email template fields

export const emailTemplateFields = [
  // Order Confirmation Messages
  {
    category: "Order Confirmation Messages",
    fields: [
      {
        label: "Admin Message",
        name: "order_mail_admin_message",
        type: "richtext",
        required: true,
        description: "Message sent to admin when new order is placed"
      },
      {
        label: "Customer Message", 
        name: "order_mail_customer_message",
        type: "richtext",
        required: true,
        description: "Message sent to customer when order is placed"
      }
    ]
  },
  // Order Delivered Messages
  {
    category: "Order Delivered Messages",
    fields: [
      {
        label: "Main Title",
        name: "order_delivered_title",
        type: "text",
        required: true,
        description: "Main title of the delivery email"
      },
      {
        label: "Success Title",
        name: "order_delivered_success_title",
        type: "text",
        required: true,
        description: "Success message title"
      },
      {
        label: "Success Message",
        name: "order_delivered_success_message",
        type: "richtext",
        required: true,
        description: "Success message content"
      },
      {
        label: "Greeting",
        name: "order_delivered_greeting",
        type: "text",
        required: true,
        description: "Greeting message"
      },
      {
        label: "Main Message",
        name: "order_delivered_main_message",
        type: "richtext",
        required: true,
        description: "Main delivery message"
      },
      {
        label: "Thank You Message",
        name: "order_delivered_thank_you_message",
        type: "richtext",
        required: true,
        description: "Thank you message"
      },
      {
        label: "Support Message",
        name: "order_delivered_support_message",
        type: "richtext",
        required: true,
        description: "Support contact message"
      }
    ]
  },
  // Order Status Updated Messages
  {
    category: "Order Status Updated Messages",
    fields: [
      {
        label: "Main Title",
        name: "order_status_updated_title",
        type: "text",
        required: true,
        description: "Main title of status update email"
      },
      {
        label: "Greeting",
        name: "order_status_updated_greeting",
        type: "text",
        required: true,
        description: "Greeting message"
      },
      {
        label: "Update Message",
        name: "order_status_updated_message",
        type: "richtext",
        required: true,
        description: "Status update message"
      },
      {
        label: "Shipped Message",
        name: "order_status_shipped_message",
        type: "richtext",
        required: true,
        description: "Message when status is 'shipped'"
      },
      {
        label: "Delivered Message",
        name: "order_status_delivered_message",
        type: "richtext",
        required: true,
        description: "Message when status is 'delivered'"
      },
      {
        label: "Processing Message",
        name: "order_status_processing_message",
        type: "richtext",
        required: true,
        description: "Message when status is 'processing'"
      },
      {
        label: "Support Message",
        name: "order_status_support_message",
        type: "richtext",
        required: true,
        description: "Support contact message"
      }
    ]
  },
  // Order Shipped Messages
  {
    category: "Order Shipped Messages",
    fields: [
      {
        label: "Main Title",
        name: "order_shipped_title",
        type: "text",
        required: true,
        description: "Main title of shipping email"
      },
      {
        label: "On The Way Title",
        name: "order_shipped_way_title",
        type: "text",
        required: true,
        description: "'On The Way' title"
      },
      {
        label: "On The Way Message",
        name: "order_shipped_way_message",
        type: "richtext",
        required: true,
        description: "'On The Way' message"
      },
      {
        label: "Greeting",
        name: "order_shipped_greeting",
        type: "text",
        required: true,
        description: "Greeting message"
      },
      {
        label: "Main Message",
        name: "order_shipped_main_message",
        type: "richtext",
        required: true,
        description: "Main shipping message"
      },
      {
        label: "Tracking Message",
        name: "order_shipped_tracking_message",
        type: "richtext",
        required: true,
        description: "Tracking information message"
      }
    ]
  },
  // Payment Completed Messages
  {
    category: "Payment Completed Messages",
    fields: [
      {
        label: "Main Title",
        name: "payment_completed_title",
        type: "text",
        required: true,
        description: "Main title of payment email"
      },
      {
        label: "Payment Received Title",
        name: "payment_completed_received_title",
        type: "text",
        required: true,
        description: "'Payment Received' title"
      },
      {
        label: "Payment Received Message",
        name: "payment_completed_received_message",
        type: "richtext",
        required: true,
        description: "Payment received message"
      },
      {
        label: "Greeting",
        name: "payment_completed_greeting",
        type: "text",
        required: true,
        description: "Greeting message"
      },
      {
        label: "Main Message",
        name: "payment_completed_main_message",
        type: "richtext",
        required: true,
        description: "Main payment message"
      },
      {
        label: "Preparation Message",
        name: "payment_completed_preparation_message",
        type: "richtext",
        required: true,
        description: "Order preparation message"
      },
      {
        label: "Support Message",
        name: "payment_completed_support_message",
        type: "richtext",
        required: true,
        description: "Support contact message"
      }
    ]
  },
  // Order Processing Messages
  {
    category: "Order Processing Messages",
    fields: [
      {
        label: "Main Title",
        name: "order_processing_title",
        type: "text",
        required: true,
        description: "Main title of the processing email"
      },
      {
        label: "Working Title",
        name: "order_processing_working_title",
        type: "text",
        required: true,
        description: "'We're Working On It!' title"
      },
      {
        label: "Working Message",
        name: "order_processing_working_message",
        type: "richtext",
        required: true,
        description: "Message about order being prepared"
      },
      {
        label: "Greeting",
        name: "order_processing_greeting",
        type: "text",
        required: true,
        description: "Greeting message with customer email"
      },
      {
        label: "Main Message",
        name: "order_processing_main_message",
        type: "richtext",
        required: true,
        description: "Main processing message with order details"
      },
      {
        label: "Delivery Title",
        name: "order_processing_delivery_title",
        type: "text",
        required: true,
        description: "Delivery information section title"
      },
      {
        label: "Delivery Message",
        name: "order_processing_delivery_message",
        type: "richtext",
        required: true,
        description: "Delivery timeline and tracking information"
      },
      {
        label: "Expected Date Label",
        name: "order_processing_expected_date",
        type: "text",
        required: true,
        description: "Label for expected delivery date"
      },
      {
        label: "Support Message",
        name: "order_processing_support_message",
        type: "richtext",
        required: true,
        description: "Support contact message"
      }
    ]
  },
  // Basic Mail Template
  {
    category: "Basic Mail Template",
    fields: [
      {
        label: "Email Header",
        name: "basic_mail_header",
        type: "richtext",
        required: true,
        description: "Email header content"
      }
    ]
  }
];

// Helper function to add new field to existing category
export const addFieldToCategory = (categoryName, field) => {
  const category = emailTemplateFields.find(cat => cat.category === categoryName);
  if (category) {
    category.fields.push(field);
  } else {
    console.warn(`Category "${categoryName}" not found`);
  }
};

// Helper function to add new category
export const addNewCategory = (category) => {
  emailTemplateFields.push(category);
};

// Helper function to get all field names
export const getAllFieldNames = () => {
  return emailTemplateFields.flatMap(category => 
    category.fields.map(field => field.name)
  );
};

// Helper function to get field by name
export const getFieldByName = (fieldName) => {
  for (const category of emailTemplateFields) {
    const field = category.fields.find(f => f.name === fieldName);
    if (field) return field;
  }
  return null;
};

// Field types available
export const FIELD_TYPES = {
  TEXT: "text",
  RICHTEXT: "richtext",
  EMAIL: "email",
  NUMBER: "number",
  URL: "url",
  TEXTAREA: "textarea"
};

// Example of how to add a new field:
/*
addFieldToCategory("Order Confirmation Messages", {
  label: "New Field",
  name: "new_field_name",
  type: "text",
  required: false,
  description: "Description of the new field"
});
*/

// Example of how to add a new category:
/*
addNewCategory({
  category: "New Category Name",
  fields: [
    {
      label: "Field 1",
      name: "new_field_1",
      type: "text",
      required: true,
      description: "Description"
    }
  ]
});
*/
